import { Container, Grid, Link, Text } from "basis";
import { formatAmount } from "library/moneyUtils";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { State } from "./types";

interface Props {
  state: State;
}

export const AlreadyAtMinimumCreditLimit = ({ state }: Props) => {
  const { accountInfo } = state;
  if (!accountInfo) return null;
  const { cardMinCreditLimit } = accountInfo;

  return (
    <Grid rowsGap="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard
          cardName={accountInfo.cardName}
          cardEndsWith={accountInfo.cardEndsWith}
        />
      </Container>
      <SvgInline name="reduce-credit-limit" size="92" />
      <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
        You're already at the minimum credit limit for this account
      </Text>
      <Text>
        The minimum credit limit for {accountInfo.cardName} is{" "}
        {formatAmount(cardMinCreditLimit)}.
      </Text>
      <Container>
        <Link appearance="primary-button" href="/" newTab={false}>
          Go to overview
        </Link>
      </Container>
    </Grid>
  );
};
